
    <template>
      <section class="doc-article monkey-view-doc">
        <h1>Dropdown 下拉菜单</h1>
<p>展示一组下拉数据。</p>
<h2 id="dai-ma-shi-li" class="anchor-title">代码示例 <a class="header-anchor" href="#dai-ma-shi-li">#</a></h2>
<code-wrap id="JCYF">
                <template slot="description"><p>配合<code>dropdownMenu</code>和<code>dropdownItem</code>组件使用。</p>
</template>
                <template slot="title">基础用法 <a href="#JCYF" data-title="基础用法">#</a></template>
                <template slot="source"><monkey-view-demo0 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Dropdown&gt;
        &lt;Button type=&quot;text&quot;&gt;下拉菜单 &lt;Icon type=&quot;down&quot;&gt;&lt;/Icon&gt;&lt;/Button&gt;
        &lt;DropdownMenu slot=&quot;menu&quot;&gt;
            &lt;DropdownItem&gt;菜单一&lt;/DropdownItem&gt;
            &lt;DropdownItem&gt;菜单二&lt;/DropdownItem&gt;
            &lt;DropdownItem disabled&gt;菜单三&lt;/DropdownItem&gt;
            &lt;DropdownItem&gt;菜单四&lt;/DropdownItem&gt;
            &lt;DropdownItem divided&gt;菜单五&lt;/DropdownItem&gt;
        &lt;/DropdownMenu&gt;
    &lt;/Dropdown&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
        data(){
            return {
                
            }
        },
    }
&lt;/script&gt;

</code></pre></div></template></code-wrap>
<code-wrap id="CFFS">
                <template slot="description"><p><code>trigger</code>属性设置触发方式，可选值有 <code>hover</code> <code>click</code> <code>contextmenu</code> <code>custom</code>。默认为<code>hover</code>。</p>
<p>自定义触发方式时需要自主实现打开关闭。</p>
</template>
                <template slot="title">触发方式 <a href="#CFFS" data-title="触发方式">#</a></template>
                <template slot="source"><monkey-view-demo1 /></template>
                <template slot="highlight">
<p></p>
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Dropdown&gt;
        &lt;Button type=&quot;text&quot;&gt;Hover触发 &lt;Icon type=&quot;down&quot;&gt;&lt;/Icon&gt;&lt;/Button&gt;
        &lt;DropdownMenu slot=&quot;menu&quot;&gt;
            &lt;DropdownItem&gt;菜单一&lt;/DropdownItem&gt;
            &lt;DropdownItem&gt;菜单二&lt;/DropdownItem&gt;
            &lt;DropdownItem disabled&gt;菜单三&lt;/DropdownItem&gt;
            &lt;DropdownItem&gt;菜单四&lt;/DropdownItem&gt;
            &lt;DropdownItem divided&gt;菜单五&lt;/DropdownItem&gt;
        &lt;/DropdownMenu&gt;
    &lt;/Dropdown&gt;
    &lt;Dropdown trigger=&quot;click&quot; :hide-on-click=&quot;false&quot; :renderHtml=&quot;true&quot;&gt;
        &lt;Button type=&quot;text&quot;&gt;点击触发 &lt;Icon type=&quot;down&quot;&gt;&lt;/Icon&gt;&lt;/Button&gt;
        &lt;DropdownMenu slot=&quot;menu&quot;&gt;
            &lt;DropdownItem&gt;菜单一&lt;/DropdownItem&gt;
            &lt;DropdownItem&gt;菜单二&lt;/DropdownItem&gt;
            &lt;DropdownItem disabled&gt;菜单三&lt;/DropdownItem&gt;
            &lt;DropdownItem&gt;菜单四&lt;/DropdownItem&gt;
            &lt;DropdownItem divided&gt;菜单五&lt;/DropdownItem&gt;
        &lt;/DropdownMenu&gt;
    &lt;/Dropdown&gt;
    &lt;Dropdown trigger=&quot;contextmenu&quot;&gt;
        &lt;Button type=&quot;text&quot;&gt;右键触发 &lt;Icon type=&quot;down&quot;&gt;&lt;/Icon&gt;&lt;/Button&gt;
        &lt;DropdownMenu slot=&quot;menu&quot;&gt;
            &lt;DropdownItem&gt;菜单一&lt;/DropdownItem&gt;
            &lt;DropdownItem&gt;菜单二&lt;/DropdownItem&gt;
            &lt;DropdownItem disabled&gt;菜单三&lt;/DropdownItem&gt;
            &lt;DropdownItem&gt;菜单四&lt;/DropdownItem&gt;
            &lt;DropdownItem divided&gt;菜单五&lt;/DropdownItem&gt;
        &lt;/DropdownMenu&gt;
    &lt;/Dropdown&gt;
    &lt;Dropdown :visible=&quot;visible&quot; trigger=&quot;custom&quot; :dropdownMatchSelectWidth=&quot;false&quot;&gt;
        &lt;Button type=&quot;text&quot; @click=&quot;visible = true&quot;&gt;自定义触发 &lt;Icon type=&quot;down&quot;&gt;&lt;/Icon&gt;&lt;/Button&gt;
        &lt;DropdownMenu slot=&quot;menu&quot;&gt;
            &lt;p style=&quot;padding: 5px;&quot;&gt;可以自定义需要的内容;自定义实现打开和关闭。&lt;/p&gt;
            &lt;div style=&quot;padding: 5px;text-align: right&quot;&gt;
                &lt;Button type=&quot;primary&quot; @click=&quot;visible = false&quot;&gt;关闭&lt;/Button&gt;
&lt;/div&gt;
        &lt;/DropdownMenu&gt;
    &lt;/Dropdown&gt;
    
&lt;/template&gt;
&lt;script&gt;
    export default {
        data(){
            return {
                visible: false,
            }
        },
    }
&lt;/script&gt;

</code></pre></div></template></code-wrap>
<code-wrap id="QTSY">
                <template slot="description"><p>嵌套使用，多级菜单。</p>
</template>
                <template slot="title">嵌套使用 <a href="#QTSY" data-title="嵌套使用">#</a></template>
                <template slot="source"><monkey-view-demo2 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Dropdown&gt;
        &lt;Button type=&quot;text&quot;&gt;嵌套菜单 &lt;Icon type=&quot;down&quot;&gt;&lt;/Icon&gt;&lt;/Button&gt;
        &lt;DropdownMenu slot=&quot;menu&quot;&gt;
            &lt;DropdownItem&gt;菜单一&lt;/DropdownItem&gt;
            &lt;DropdownItem&gt;菜单二&lt;/DropdownItem&gt;
            &lt;Dropdown placement=&quot;right-start&quot;&gt;
                &lt;DropdownItem&gt;菜单三 &lt;Icon type=&quot;right&quot;&gt;&lt;/Icon&gt;&lt;/DropdownItem&gt;
                &lt;DropdownMenu slot=&quot;menu&quot;&gt;
                    &lt;DropdownItem&gt;二级菜单一&lt;/DropdownItem&gt;
                    &lt;DropdownItem&gt;二级菜单二&lt;/DropdownItem&gt;
                &lt;/DropdownMenu&gt;
            &lt;/Dropdown&gt;
            &lt;DropdownItem&gt;菜单四&lt;/DropdownItem&gt;
            &lt;DropdownItem divided&gt;菜单五&lt;/DropdownItem&gt;
        &lt;/DropdownMenu&gt;
    &lt;/Dropdown&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
        data(){
            return {
                
            }
        },
    }
&lt;/script&gt;

</code></pre></div></template></code-wrap>
<h2 id="api" class="anchor-title">API <a class="header-anchor" href="#api">#</a></h2>
<h3 id="dropdown-props" class="anchor-title">Dropdown props <a class="header-anchor" href="#dropdown-props">#</a></h3>
<table class="doc-table"><thead>
<tr>
<th>属性</th>
<th>类型</th>
<th>说明</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>trigger</td>
<td>String</td>
<td>触发菜单打开的方式,可选值<code>hover</code> <code>click</code> <code>contextmenu</code> <code>custom</code></td>
<td>hover</td>
</tr>
<tr>
<td>visible</td>
<td>Boolean</td>
<td>是否打开</td>
<td>false</td>
</tr>
<tr>
<td>transition</td>
<td>String</td>
<td>打开关闭的动画</td>
<td>slideUp</td>
</tr>
<tr>
<td>placement</td>
<td>String</td>
<td>下拉菜单的位置</td>
<td>bottom</td>
</tr>
<tr>
<td>dropdownMatchSelectWidth</td>
<td>Boolean</td>
<td>下拉框宽度是否和触发元素同宽</td>
<td>false</td>
</tr>
<tr>
<td>hide-on-click</td>
<td>Boolean</td>
<td>点击item后是否关闭菜单</td>
<td>true</td>
</tr>
<tr>
<td>renderHtml</td>
<td>HTMLElement, Boolean</td>
<td>下拉框渲染到的位置</td>
<td>false</td>
</tr>
</tbody>
</table>
<h3 id="dropdown-event" class="anchor-title">Dropdown event <a class="header-anchor" href="#dropdown-event">#</a></h3>
<table class="doc-table"><thead>
<tr>
<th>事件名</th>
<th>说明</th>
<th>返回值</th>
</tr>
</thead>
<tbody>
<tr>
<td>click-item</td>
<td>点击菜单项触发,返回菜单项的name</td>
<td>name</td>
</tr>
<tr>
<td>click-outside</td>
<td>点击外部触发</td>
<td>event</td>
</tr>
<tr>
<td>visible-change</td>
<td>可见状态变化时触发</td>
<td>visible</td>
</tr>
</tbody>
</table>
<h3 id="dropitem-props" class="anchor-title">DropItem props <a class="header-anchor" href="#dropitem-props">#</a></h3>
<table class="doc-table"><thead>
<tr>
<th>属性</th>
<th>类型</th>
<th>说明</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>name</td>
<td>String</td>
<td>菜单项的名称</td>
<td>-</td>
</tr>
<tr>
<td>disabled</td>
<td>Boolean</td>
<td>是否禁用</td>
<td>-</td>
</tr>
<tr>
<td>divided</td>
<td>Boolean</td>
<td>是否显示分割线</td>
<td>-</td>
</tr>
</tbody>
</table>

      </section>
    </template>
    <script>
      export default {
        name: 'component-doc',
        components: {
          "monkey-view-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Dropdown',[_c('Button',{attrs:{"type":"text"}},[_vm._v("下拉菜单 "),_c('Icon',{attrs:{"type":"down"}})],1),_vm._v(" "),_c('DropdownMenu',{attrs:{"slot":"menu"},slot:"menu"},[_c('DropdownItem',[_vm._v("菜单一")]),_vm._v(" "),_c('DropdownItem',[_vm._v("菜单二")]),_vm._v(" "),_c('DropdownItem',{attrs:{"disabled":""}},[_vm._v("菜单三")]),_vm._v(" "),_c('DropdownItem',[_vm._v("菜单四")]),_vm._v(" "),_c('DropdownItem',{attrs:{"divided":""}},[_vm._v("菜单五")])],1)],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data(){
            return {
                
            }
        },
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo1": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Dropdown',[_c('Button',{attrs:{"type":"text"}},[_vm._v("Hover触发 "),_c('Icon',{attrs:{"type":"down"}})],1),_vm._v(" "),_c('DropdownMenu',{attrs:{"slot":"menu"},slot:"menu"},[_c('DropdownItem',[_vm._v("菜单一")]),_vm._v(" "),_c('DropdownItem',[_vm._v("菜单二")]),_vm._v(" "),_c('DropdownItem',{attrs:{"disabled":""}},[_vm._v("菜单三")]),_vm._v(" "),_c('DropdownItem',[_vm._v("菜单四")]),_vm._v(" "),_c('DropdownItem',{attrs:{"divided":""}},[_vm._v("菜单五")])],1)],1),_vm._v(" "),_c('Dropdown',{attrs:{"trigger":"click","hide-on-click":false,"renderHtml":true}},[_c('Button',{attrs:{"type":"text"}},[_vm._v("点击触发 "),_c('Icon',{attrs:{"type":"down"}})],1),_vm._v(" "),_c('DropdownMenu',{attrs:{"slot":"menu"},slot:"menu"},[_c('DropdownItem',[_vm._v("菜单一")]),_vm._v(" "),_c('DropdownItem',[_vm._v("菜单二")]),_vm._v(" "),_c('DropdownItem',{attrs:{"disabled":""}},[_vm._v("菜单三")]),_vm._v(" "),_c('DropdownItem',[_vm._v("菜单四")]),_vm._v(" "),_c('DropdownItem',{attrs:{"divided":""}},[_vm._v("菜单五")])],1)],1),_vm._v(" "),_c('Dropdown',{attrs:{"trigger":"contextmenu"}},[_c('Button',{attrs:{"type":"text"}},[_vm._v("右键触发 "),_c('Icon',{attrs:{"type":"down"}})],1),_vm._v(" "),_c('DropdownMenu',{attrs:{"slot":"menu"},slot:"menu"},[_c('DropdownItem',[_vm._v("菜单一")]),_vm._v(" "),_c('DropdownItem',[_vm._v("菜单二")]),_vm._v(" "),_c('DropdownItem',{attrs:{"disabled":""}},[_vm._v("菜单三")]),_vm._v(" "),_c('DropdownItem',[_vm._v("菜单四")]),_vm._v(" "),_c('DropdownItem',{attrs:{"divided":""}},[_vm._v("菜单五")])],1)],1),_vm._v(" "),_c('Dropdown',{attrs:{"visible":_vm.visible,"trigger":"custom","dropdownMatchSelectWidth":false}},[_c('Button',{attrs:{"type":"text"},on:{"click":function($event){_vm.visible = true}}},[_vm._v("自定义触发 "),_c('Icon',{attrs:{"type":"down"}})],1),_vm._v(" "),_c('DropdownMenu',{attrs:{"slot":"menu"},slot:"menu"},[_c('p',{staticStyle:{"padding":"5px"}},[_vm._v("可以自定义需要的内容;自定义实现打开和关闭。")]),_vm._v(" "),_c('div',{staticStyle:{"padding":"5px","text-align":"right"}},[_c('Button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.visible = false}}},[_vm._v("关闭")])],1)])],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data(){
            return {
                visible: false,
            }
        },
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo2": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Dropdown',[_c('Button',{attrs:{"type":"text"}},[_vm._v("嵌套菜单 "),_c('Icon',{attrs:{"type":"down"}})],1),_vm._v(" "),_c('DropdownMenu',{attrs:{"slot":"menu"},slot:"menu"},[_c('DropdownItem',[_vm._v("菜单一")]),_vm._v(" "),_c('DropdownItem',[_vm._v("菜单二")]),_vm._v(" "),_c('Dropdown',{attrs:{"placement":"right-start"}},[_c('DropdownItem',[_vm._v("菜单三 "),_c('Icon',{attrs:{"type":"right"}})],1),_vm._v(" "),_c('DropdownMenu',{attrs:{"slot":"menu"},slot:"menu"},[_c('DropdownItem',[_vm._v("二级菜单一")]),_vm._v(" "),_c('DropdownItem',[_vm._v("二级菜单二")])],1)],1),_vm._v(" "),_c('DropdownItem',[_vm._v("菜单四")]),_vm._v(" "),_c('DropdownItem',{attrs:{"divided":""}},[_vm._v("菜单五")])],1)],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data(){
            return {
                
            }
        },
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  